export var CUSTOMER_PROPERTY_NAME = /* @__PURE__ */ ((CUSTOMER_PROPERTY_NAME2) => {
  CUSTOMER_PROPERTY_NAME2["POPUP_ID"] = "popup_id";
  return CUSTOMER_PROPERTY_NAME2;
})(CUSTOMER_PROPERTY_NAME || {});
